export default __webpack_public_path__ + "static/media/stretch4.1c25df92.png";